import { Separator as RadixSeparator } from '@radix-ui/react-context-menu';
import { forwardRef, type HTMLAttributes } from 'react';
import { separatorClassNames } from '../common';

interface SeparatorProps extends HTMLAttributes<HTMLDivElement> {}

const Separator = forwardRef<HTMLDivElement, SeparatorProps>((props, ref) => {
  return <RadixSeparator ref={ref} className={separatorClassNames} {...props} />;
});

Separator.displayName = 'Separator';
export default Separator;
